module.exports = __webpack_public_path__ + "Message.png";